import React from 'react';
import { JRCObjectList, JRCObjectListProps } from '../JRCObjectList/JRCObjectList';
import { jGroupLittle } from 'jamespot-user-api';

export type JRCGroupListProps = JRCObjectListProps<jGroupLittle>;

export const JRCGroupList = (props: JRCGroupListProps) => {
    return <JRCObjectList {...props} />;
};
